/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

window.theme.wrapRteTables();

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}
//# sourceMappingURL=global.js.map

/* Show More / Show Less funkcia pre Rich Text sekciu s Delimiterom - FINALNA OPRAVA DELIMITERA */
function initializeSeosplitter() {
    const contentWrappers = document.querySelectorAll('[data-seo-splitter]');
    // Definovanie Delimitera ako Regulárny Výraz (hľadáme //Zobraziť viac// s prípadnými medzerami/zalomeniami)
    const delimiter = /((?:\r\n|\r|\n)*\/\/Zobraziť viac\/\/(?:\r\n|\r|\n)*)/;

    contentWrappers.forEach(wrapper => {
        let fullHtml = '';
        const innerDiv = wrapper.querySelector('.metafield-rich_text_field');
        
        if (innerDiv) {
            // 1. Získame obsah a odstránime pôvodný div
            fullHtml = innerDiv.innerHTML.trim();
            innerDiv.remove(); 
        } else {
            fullHtml = wrapper.innerHTML.trim();
        }
        
        // **NOVINKA:** Hľadáme delimiter pomocou silného regulárneho výrazu
        if (!fullHtml || !delimiter.test(fullHtml)) {
            // Ak delimiter nie je nájdený, zastavíme sa a text ostane zobrazený
            return;
        }

        // Rozdelenie obsahu pomocou regulárneho výrazu
        // Používame .split() s regulárnym výrazom, aby sme správne rozdelili
        const parts = fullHtml.split(delimiter);
        
        // Prvá časť bude text pred delimiterom. (Index 0)
        // Druhá časť (ak existuje) je prázdny reťazec alebo Zobraziť viac (Index 1).
        // Tretia časť je text za delimiterom. (Index 2)
        
        const shortContentHtml = parts[0].trim();
        
        // Zostavenie plného HTML (spojíme prvú časť s textom za delimiterom)
        // Odstránime Delimiter z plného obsahu a spojíme všetko dokopy:
        let fullContentHtml = shortContentHtml;
        for (let i = 2; i < parts.length; i++) {
             fullContentHtml += parts[i];
        }
        fullContentHtml = fullContentHtml.trim();


        // 3. Vytvorenie HTML štruktúry
        const newHtmlStructure = `
            <div class="seo-content-wrapper" data-show-more-wrapper>
                
                <div class="rte seo-content-short" data-content-short>
                    ${shortContentHtml}
                    <span class="rte__link-button js-show-more-button" role="button" tabindex="0" data-action="show">
                        Zobraziť viac
                    </span>
                </div>
                
                <div class="rte seo-content-full is-hidden" data-content-full>
                    ${fullContentHtml}
                    <span class="rte__link-button js-show-more-button" role="button" tabindex="0" data-action="hide">
                        Zobraziť menej
                    </span>
                </div>
                
            </div>
        `;

        // 4. Prepíšeme pôvodný kontajner obsahom
        wrapper.innerHTML = newHtmlStructure;
    });

    // 5. Inicializácia funkcie prepínania
    setupShowMoreListeners();
}

// Funkcia setupShowMoreListeners zostáva nezmenená (ako v predchádzajúcej odpovedi)
function setupShowMoreListeners() {
    const wrappers = document.querySelectorAll('[data-show-more-wrapper]');

    wrappers.forEach(wrapper => {
        const shortContent = wrapper.querySelector('[data-content-short]');
        const fullContent = wrapper.querySelector('[data-content-full]');
        const buttons = wrapper.querySelectorAll('.js-show-more-button');

        if (!shortContent || !fullContent || buttons.length === 0) {
            return;
        }

        buttons.forEach(button => {
            button.addEventListener('click', (event) => {
                const action = event.currentTarget.dataset.action;

                if (action === 'show') {
                    shortContent.classList.add('is-hidden');
                    fullContent.classList.remove('is-hidden');
                } else if (action === 'hide') {
                    fullContent.classList.add('is-hidden');
                    shortContent.classList.remove('is-hidden');
                    wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        });
    });
}

// Spustite funkciu po načítaní celej DOM štruktúry
document.addEventListener('DOMContentLoaded', initializeSeosplitter);